/**
 * Tipi per Template Documenti
 */

export type TipoTemplate = 'offerta' | 'ordine' | 'checklist' | 'audit' | 'certificazione' | 'generico'

export interface TemplateDocumento {
  id: string
  nome: string
  tipo: TipoTemplate
  descrizione?: string
  filename_originale?: string
  placeholder_map: Record<string, string>
  is_active: boolean
  is_default: boolean
  has_file_processato: boolean
  created_at: string
}

export interface PlaceholderSuggestion {
  testo_originale: string
  placeholder_suggerito: string
  placeholder_suggerito_originale: string  // Suggerimento originale di Claude (anche se non disponibile)
  contesto: string
  confidence: number
  is_valid: boolean  // true se il placeholder è disponibile nel sistema
}

export interface AnalisiResult {
  suggerimenti: PlaceholderSuggestion[]
  placeholder_disponibili: Record<string, string>
}

export const TIPI_TEMPLATE: { value: TipoTemplate; label: string }[] = [
  { value: 'offerta', label: 'Offerta' },
  { value: 'ordine', label: 'Ordine' },
  { value: 'checklist', label: 'Checklist' },
  { value: 'audit', label: 'Audit' },
  { value: 'certificazione', label: 'Certificazione' },
  { value: 'generico', label: 'Generico' },
]
